<!-- INPUT SWITCH

//utilização:
  <input-switch label="teste" v-model="entity.part.cliente" value-checked="S" value-unchecked="N" :metadata-field="metadata.part.cliente"></input-switch>

  <input-switch type="Success" v-model="entity.part.cliente" value-checked="S" value-unchecked="N" :metadata-field="metadata.part.cliente"></input-switch>


TYPE: success, primary, info, warning, danger, default

-->

<script>
//https://br.vuejs.org/v2/guide/components.html#Usando-v-on-com-Eventos-Personalizados

export default {
    props: {
      'label': String,
      'valueChecked': [String, Boolean],
      'valueUnchecked': [String, Boolean],
      'metadataField': Object,
      'value': [String, Boolean],
      'type': String,
    },

    data () {
      return {
        vvalue: this.value,
        vlabel: '',
        help: '',
        bHelp: false,
        checked: false
      }
    },

    computed: {
      _class: function () {
        if (this.type) {
          return this.type
        } else {
          return 'default'
        }
      }

    },

    methods: {
      updateValue: function(value) {
        if (value) {
          this.vvalue = this.valueChecked
          this.checked = true
        } else {
          this.vvalue = this.valueUnchecked
          this.checked = false
        }
        this.$emit('input', this.vvalue)
      },
    },

    watch: {
      value: function (newValue) {
        this.vvalue = newValue
        if (this.vvalue == this.valueChecked) {
          this.checked = true
        } else {
          this.checked = false
        }
      }
    },

    created () {

      this.vvalue = this.value
      if (this.vvalue == this.valueChecked) {
        this.checked = true
      } else {
        this.checked = false
      }

      if (this.metadataField) {
        if (this.metadataField.help) {
          this.bHelp = true
          this.help = this.metadataField.help
        }
        if (this.metadataField.label) {
          this.vlabel = this.metadataField.label
        }
      }
      if (this.label) {
        this.vlabel = this.label
      }
    }

}
</script>

<template>

    <div class="form-check d-flex align-items-center">
        <!-- <label class="lbl-edit" data-toggle="tooltip" data-placement="top" :title="help">{{ vlabel }} <span v-if="bHelp" class="badge badge-secondary">?</span></label>
        <br>
        <label class="switch">
          <input
            type="checkbox"
            ref="cb"
            :class="_class"
            :checked="checked"
            :value="vvalue"
            @change="updateValue($event.target.checked)"><span v-if="bHelp" class="badge badge-secondary">?</span>
                    <span class="slider round"></span>
        </label> -->

        <label class="switch">
          <input
            type="checkbox"
            ref="cb"
            :class="_class"
            :checked="checked"
            :value="vvalue"
            @change="updateValue($event.target.checked)">
                    <span class="slider round"></span>
        </label>
        <label class="ml-3 lbl-edit" data-toggle="tooltip" data-placement="top" :title="help">{{ vlabel }} <span v-if="bHelp" ><i class="fa fa-question-circle-o" style="color: #07a7cf;"></i>
</span></label>
            </div>
</template>

<style>
/* TOGGLE SWITCH CHECKBOX */

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
  /* float:right; */
}

/* Hide default HTML checkbox */
.switch input {display:none;}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input.default:checked + .slider {
  background-color: #444;
}
input.primary:checked + .slider {
  background-color: #2196F3;
}
input.success:checked + .slider {
  background-color: #8bc34a;
}
input.info:checked + .slider {
  background-color: #3de0f5;
}
input.warning:checked + .slider {
  background-color: #FFC107;
}
input.danger:checked + .slider {
  background-color: #f44336;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

/* FIM TOGGLE SWITCH CHECKBOX */


</style>



// WEBPACK FOOTER //
// src/components/input-switch.vue